'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _elementRegistry = require('../../common/elements/elementRegistry');

var elementRegistry = _interopRequireWildcard(_elementRegistry);

var _gridUtils = require('../utils/grid/gridUtils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElementPresentational = function ElementPresentational(props) {
    var element = props.element,
        isDragging = props.isDragging,
        dragOrigin = props.dragOrigin;

    var DisplayElement = elementRegistry.getElementPresentationalComponent(element.get('elementType'));

    if (!DisplayElement) return null;

    var styles = _extends({}, (0, _gridUtils.getNormalisedFontStyle)(props));

    if (dragOrigin) {
        styles.transformOrigin = dragOrigin.x + 'px ' + dragOrigin.y + 'px';
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Element', { isDragging: isDragging }), style: styles },
        _react2.default.createElement(DisplayElement, props)
    );
};

ElementPresentational.propTypes = {
    element: _propTypes2.default.object.isRequired,
    isDragging: _propTypes2.default.bool,
    gridSize: _propTypes2.default.number.isRequired,
    documentMode: _propTypes2.default.bool,
    dragOrigin: _propTypes2.default.object
};

exports.default = ElementPresentational;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/ElementPresentational.js
// module id = 1948
// module chunks = 0